export default "__VITE_ASSET__Dtq5xLh3__"